/**
 * @file AuthorInfo/component.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import PropTypes from "prop-types";
import AuthorImage from "../../../../../AuthorImage/component";

/**
 * Author name and image.
 *
 * @param {Object} props The component props
 * @returns {React.Component} The AuthorInfo component
 */
export function AuthorInfo({ image, name }) {
    return (
        <div className="authorInfo" data-testid="author-info">
            <AuthorImage src={image} title={name} />
            <div className="authorName">{name}</div>
        </div>
    );
}

AuthorInfo.propTypes = {
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
};

export default AuthorInfo;
